module.exports = __webpack_public_path__ + "img/task-timelimit.6feeb493.png";